export default __webpack_public_path__ + "static/media/fr-flag.3424ac77.svg";